import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  ElementRef, EventEmitter, HostListener, Input,
  Output,
  QueryList, ViewChild,
  ViewChildren
} from '@angular/core';
import anime from 'animejs/lib/anime.es.js';
import { NgStyle } from "@angular/common";
import {BehaviorSubject} from "rxjs";

@Component({
    selector: 'app-tdj',
    imports: [
    NgStyle
],
    templateUrl: './tdj.component.html',
    styleUrl: './tdj.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TdjComponent {
  gameEnabled = true;
  cards: undefined[] = new Array(22);
  selectedCards: number[] = [];
  @ViewChild('deck') deckElt?: ElementRef<HTMLDivElement>;
  @ViewChildren('card') cardElts?: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChildren('space') spaceElts?: QueryList<ElementRef<HTMLDivElement>>;
  @Output() drawingEvent = new EventEmitter<[number, number, number]>();
  @Input('cards') externalCards = new BehaviorSubject<[number, number, number] | undefined>(undefined);

  @HostListener('window:resize')
  public detectResize(): void {
    this.placeCards(true);
    this.selectedCards.forEach((cardIdx, placeIdx) => {
      this.placeCardSelected(this.cardElts!.get(cardIdx)!.nativeElement, placeIdx, true);
    });
  }

  constructor() {
    afterNextRender(() => {
      this.placeCards();
    });
  }

  private placeCards(redo = false) {
    const elts = this.cardElts?.map((elt, idx) => {
      return this.selectedCards.includes(idx) ? null : elt.nativeElement;
    }).filter(v => v);
    const deckWidth = this.deckElt?.nativeElement.offsetWidth!;
    const cardWidth = elts![0]!.offsetWidth;

    const from = (deckWidth / -2) + (cardWidth / 2)
    const to = (deckWidth / 2) - (cardWidth / 2);

    const distance = to - from;
    const timeline = anime.timeline();
    if (!redo) {
      timeline.add({
        targets: elts,
        translateX: from, // (deckWidth / 2 * -1),// -130,
        easing: 'easeOutQuad',
        duration: 500
      })
    }
    timeline
      .add({
        targets: elts,
        translateX: (elt: any, idx: number, len: number) => {
          const progress = idx / (len - 1);
          return from + (distance * progress);
        },
        easing: 'easeOutQuad',
        duration: 1000,
        complete: () => {
          this.externalCards.subscribe(cards => {
            if (!cards) return;
            cards.forEach(card => {
              this.selectCard(
                {currentTarget: this.cardElts?.toArray()[card].nativeElement} as unknown as Event,
                card,
                true
              )
            });
          });
        }
      })
  }

  selectCard($event: Event, cardNumber: number, noApiCall = false) {
    if (!this.gameEnabled) {
      return;
    }
    if (this.selectedCards.length === 3) {
      return;
    }
    if (this.selectedCards.find(s => s === cardNumber)) {
      return;
    }
    this.selectedCards.push(cardNumber);
    if (this.selectedCards.length === 3) {
      this.finishedDraw(noApiCall);
    }
    this.placeCardSelected($event.currentTarget as HTMLDivElement, this.selectedCards.length - 1);
  }

  private finishedDraw(noApiCall = false) {
    this.gameEnabled = false;
    if (!noApiCall) {
      this.drawingEvent.emit(this.selectedCards as [number, number, number]);
    }
  }

  private placeCardSelected(card: HTMLDivElement, place: number, justMove = false) {
    const cardRect = card.getBoundingClientRect();
    const spaceRect = this.spaceElts!.get(place)!.nativeElement.getBoundingClientRect();
    const dx = spaceRect.left - cardRect.left;
    const dy = spaceRect.top - cardRect.top;
    const timeline = anime.timeline();
    timeline.add({
      targets: card,
      translateX: `+=${dx}.px`, // ((this.selectedCards.length - 1) * 100) - 150,
      translateY: `+=${dy}.px`, // 175,
      rotateZ: 0,
      easing: 'easeOutQuad',
      duration: 1000
    })
      if (!justMove) {
        timeline.add({
          targets: card.querySelector('.front'),
          rotateY: [0, 180],
          easing: 'easeOutQuad',
          duration: 1000
        }, 1000)
          .add({
            targets: card.querySelector('.back'),
            rotateY: [180, 0],
            easing: 'easeOutQuad',
            duration: 1000
          }, 1000);
      }
  }
}
